export function isDate(obj: any): boolean {
  return !/Invalid|NaN/.test(new Date(obj).toString());
}
